var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEssential = function SvgEssential(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 47.25 51.73"
  }, props), _defs || (_defs = React.createElement("defs", null, React.createElement("linearGradient", {
    id: "essential_svg__b",
    x1: 664.02,
    y1: 123.64,
    x2: 663.33,
    y2: 149.92,
    gradientTransform: "rotate(73.87 415.669 -345.75)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "essential_svg__c",
    x1: 663.67,
    y1: 124.68,
    x2: 663.8,
    y2: 140.87,
    gradientTransform: "rotate(73.87 415.669 -345.75)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#e1eff8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("radialGradient", {
    id: "essential_svg__a",
    cx: 75.87,
    cy: 72.43,
    r: 149.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#171f3d"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#224e71"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2c78a0"
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3397c2"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#37a9d6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#39b0de"
  })))), _g || (_g = React.createElement("g", {
    "data-name": "Layer 2"
  }, React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-6.26-3.63-1.09-.62a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-6.26-3.63-1.09-.62a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "url(#essential_svg__a)"
  }), React.createElement("path", {
    d: "M23.63 2a7.07 7.07 0 013.55 1l14.52 8.34a7.09 7.09 0 013.55 6.14v16.77a7.15 7.15 0 01-3.55 6.16l-14.52 8.38a7.17 7.17 0 01-7.1 0l-7.18-4.14L6.64 41l-1.09-.62A7.13 7.13 0 012 34.25V17.48a7.06 7.06 0 013.55-6.14L20.08 3a7 7 0 013.55-1m0-2a9.15 9.15 0 00-4.56 1.23L4.55 9.61A9.09 9.09 0 000 17.48v16.77a9.16 9.16 0 004.55 7.89l1.09.62 6.26 3.62 7.18 4.14a9.14 9.14 0 009.09 0l14.53-8.38a9.19 9.19 0 004.55-7.89V17.48a9.11 9.11 0 00-4.55-7.87L28.18 1.23A9.11 9.11 0 0023.63 0z",
    fill: "#b9e8ee"
  }), React.createElement("path", {
    d: "M21.92 22.61c1.62-.85 5-7.29 5-7.29s-.88 7.23 0 8.84 7.29 5 7.29 5-7.38-.78-8.83 0-5 7.29-5 7.29.78-7.4 0-8.89-7.26-4.95-7.26-4.95 7.19.84 8.8 0z",
    fill: "url(#essential_svg__b)"
  }), React.createElement("path", {
    d: "M26.92 15.32s-.88 7.23 0 8.84 7.29 5 7.29 5-7.38-.78-8.83 0-5 7.29-5 7.29z",
    fill: "url(#essential_svg__c)",
    opacity: 0.95
  }))));
};
export default __webpack_public_path__ + "2ba53f9f61af678c28730bbfdb8129e2.svg";
export { SvgEssential as ReactComponent };